import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import { patchMenuLink } from 'redux/menu-links/actions';
import { setLastPatchedId } from 'redux/common/actions';
import CommonInputField from 'components/elements/inputs/CommonInputField';
import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import ProLabel from 'components/common/ProLabel';
import { connect } from 'react-redux';
import './MenuAdditionalProps.css';

function MenuAdditionalProps(props) {
  const { me, linkItem, patchMenuLink, setLastPatchedId } = props;
  const { t } = useTranslation();
  const locked = me && me.subscription && !me.subscription.ff_menu;
  const btnColor = linkItem.link_button_color;
  const fontColor = linkItem.link_font_color;

  const ButtonColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    const form = new FormData();
    form.append('link_button_color', rgba);
    patchMenuLink(linkItem.id, form);
  };

  const ButtonFontColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    const form = new FormData();
    form.append('link_font_color', rgba);
    patchMenuLink(linkItem.id, form);
  }

  const inputFieldValidation = value => {
    if (!value) {
      return t('Title should not be empty');
    }
    return null;
  }

  const urlValidation = value => {
    const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (!value) {
      return t('Title should not be empty');
    }else if (!regex.test(value)) {
      return t('Please enter a valid url');
    }
    return null;
  }

  return (
    <div className="menu-additional-props__component">
      <div className="input-field-wrapper">
        <div className="menus-btn-title">
          <CommonInputField
            initialValue={linkItem.link_title}
            placeholder={t("Price List Link Text")}
            executedFunction={value => {
              const form = new FormData();
              form.append('link_title', value);
              patchMenuLink(linkItem.id, form);
              setLastPatchedId(linkItem.id);
            }}
            validationFunction={inputFieldValidation}
          />
        </div>
        <div className="menu-btn-url">
          <CommonInputField
            initialValue={linkItem.link_url}
            placeholder={t("Price List Link URL")}
            executedFunction={value => {
              const form = new FormData();
              form.append('link_url', value);
              patchMenuLink(linkItem.id, form);
              setLastPatchedId(linkItem.id);
            }}
            validationFunction={urlValidation}
          />
        </div>
      </div>
      <div className="pickers-wrapper">
        <div className="menu-color-picker-wrapper">
          <div className="label">
            <div className="text">{t("Button color")}</div>
            <ProLabel/>
          </div>
          <div className="info-text">
            {t("You can change the color of the menu button here")}
          </div>
          <ProFeaturePlaceholder
            noKeyIcon
            locked={locked}
            placeholderContent=""
          >
            <ColorPicker
              small
              key={`menu-link-btn-color-picker-key-${linkItem.id}`}
              pickerId={`menu-link-btn-color-picker-id-${linkItem.id}`}
              color={btnColor}
              onChangeComplete={ButtonColorChange}
            />
          </ProFeaturePlaceholder>
        </div>
        <div className="menu-color-picker-wrapper">
          <div className="label">
            <div className="text">{t("Font color")}</div>
            <ProLabel/>
          </div>
          <div className="info-text">
            {t("You can change the font color of the menu button here")}
          </div>
          <ProFeaturePlaceholder
            noKeyIcon
            locked={locked}
            placeholderContent=""
          >
            <ColorPicker
              small
              key={`menu-link-btn-font-color-picker-key-${linkItem.id}`}
              pickerId={`menu-link-btn-font-color-picker-id-${linkItem.id}`}
              color={fontColor}
              onChangeComplete={ButtonFontColorChange}
            />
          </ProFeaturePlaceholder>
        </div>
      </div>
    </div>
  );
}

MenuAdditionalProps.propTypes = {
  me: PropTypes.object, 
  linkItem: PropTypes.object.isRequired, 
  patchMenuLink: PropTypes.func.isRequired, 
  setLastPatchedId: PropTypes.func.isRequired, 
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(mapStateToProps, 
  {
    patchMenuLink,
    setLastPatchedId,
  }) (MenuAdditionalProps);